// removed by extract-text-webpack-plugin
module.exports = {"moodysBlue":"#009bdf","darkCoral":"#f46036","white":"#ffffff","whiteHover":"rgb(242, 242, 242)","blue":"#009bdf","blueHover":"rgb(0, 116, 167)","red":"#e43f3f","redHover":"rgb(171, 47, 47)","green":"#12a32b","greenHover":"rgb(14, 122, 32)","gray":"#747474"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/QuiqButton.scss
// module id = 1909
// module chunks = 0